import React from 'react';
import styles from './DashboardSkeleton.module.scss';
import { Skeleton } from 'esa-ui-library';

const DashboardSkeleton = (): JSX.Element => (
	<section className={`${styles.DashboardSkeleton}`}>
		<div className={`${styles.Item}`}>
			<Skeleton variant='rounded' animation='wave' width='100%' height={300} />
		</div>
		<div className={`${styles.Item}`}>
			<Skeleton variant='rounded' animation='wave' width='100%' height={300} />
		</div>
		<div className={`${styles.Item}`}>
			<Skeleton variant='rounded' animation='wave' width='100%' height={300} />
		</div>
		<div className={`${styles.Item}`}>
			<Skeleton variant='rounded' animation='wave' width='100%' height={300} />
		</div>
	</section>
);

export { DashboardSkeleton };
